import { useState } from 'react';

export default function PairDevicePage() {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const generateCode = async () => {
    setLoading(true);
    // Request pairing code from API
    try {
      const response = await fetch('/api/auth/pair/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: 'current-user-id' }),
      });
      const data = await response.json();
      setCode(data.code);
    } catch (error) {
      console.error('Failed to generate code:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <h2 className="text-2xl font-bold mb-4">Pair New Device</h2>
        <p className="text-gray-600 mb-6">
          Generate a pairing code to connect your Companion daemon to this account.
        </p>

        {code ? (
          <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-6 text-center">
            <p className="text-sm text-gray-600 mb-2">Your pairing code:</p>
            <p className="text-4xl font-bold text-blue-600 tracking-wider mb-4">{code}</p>
            <p className="text-xs text-gray-500">
              Expires in 10 minutes. Enter this code in your Companion daemon.
            </p>
          </div>
        ) : (
          <button
            onClick={generateCode}
            disabled={loading}
            className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 disabled:opacity-50 font-medium"
          >
            {loading ? 'Generating...' : 'Generate Pairing Code'}
          </button>
        )}
      </div>
    </div>
  );
}
